module.exports = __webpack_public_path__ + "static/media/witch-piss-graphic-design.c3e810e6.jpg";